exports.install = function(Vue){
    Vue.prototype.$jumpTo = function(path, params = {}) { //全局函数1
        this.$router.push(path, params)
    };
}